import "./AboutDiscovery.module.css";
import WebsiteHeader from "@/reusable_sections/Header";
import AboutPremiumHero from "./sections/AboutPremiumHero";
import NotJustGrooming from "./sections/NotJustGrooming";
import MaintenanceMastery from "./sections/MaintenanceMastery";
import BottomBg from "./sections/BottomBg";
import Footer from "@/reusable_sections/Footer";
export default function AboutDiscoveryPage() {
  return <div>
      <WebsiteHeader />
      <AboutPremiumHero />
      <NotJustGrooming />
      <MaintenanceMastery />
      <BottomBg />
      <Footer />
    </div>;
}